export default __webpack_public_path__ + "static/media/unknownmale.a98dcfa9.jpg";